import { RouteConfig } from '../../routing/types'

const ROUTE: RouteConfig = {
  name: 'guides-index',
  path: () => `/guides`,
}

export default ROUTE
